import { Col, Row } from "reactstrap"
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard"
import ColoredHeader from "../../../../common/AdminCommonComponents/ColoredHeading/ColoredHeader"
import GradientBarChart from "../../../../common/AdminCommonComponents/Graphs/GradientBarChart/GradientBarChart"
import { TfiStatsUp, TfiStatsDown } from "react-icons/tfi"
import LineChart from "../../../../common/AdminCommonComponents/Graphs/LineChart/LineChart"
import { RiBriefcase4Line } from "react-icons/ri"
import ChartHeader from "../../../../common/AdminCommonComponents/Graphs/ChartHeader/ChartHeader"

const PartnerPerformanceDetails = () => {
  const partnerDetails = [
    { label: "Partner Name", value: "Lorem Ipsum" },
    { label: "On-time deliveries", value: "98%" },
    { label: "Return Rate", value: "2%" },
    { label: "Total Orders", value: "300" },
  ]

  const chartData = [
    {
      name: "M",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "T",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "W",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "T",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "F",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "S",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "S",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ]

  return (
    <div className="bg-white p-3 px-4 m-3 shadow">
      <GeneralBackButton />
      <div className="fw-semibold fs-4 text-center">Partner Performance</div>

      <Row className="mt-3 row-cols-1 row-cols-sm-2 row-cols-xl-3 gy-3 gy-xl-0">
        <Col>
          <InfoCard title="Partner Details" headerColor="#FBBD34" data={partnerDetails} />
        </Col>
      </Row>

      <div className="my-3">
        <ColoredHeader title="Performance" headerColor="#41B8E4" />
      </div>
      <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3">
        <Col>
          <div className="p-3 shadow rounded">
            <ChartHeader label="Revenue" value="$8900.00" Icon={TfiStatsUp} />
            <GradientBarChart uniqueId="revenue" data={chartData} gradientFrom="#CAD7FF" gradientTo="#2D55B4" />
          </div>
        </Col>
        <Col>
          <div className="p-3 shadow rounded">
            <ChartHeader label="Expenses" value="$4200.30" Icon={TfiStatsDown} />
            <GradientBarChart uniqueId="expense" data={chartData} gradientFrom="#DAC3F6" gradientTo="#533A71" />
          </div>
        </Col>
        <Col>
          <div className="p-3 shadow rounded">
            <ChartHeader label="Sales" value="5248" Icon={RiBriefcase4Line} />
            <LineChart data={chartData} />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default PartnerPerformanceDetails
